import ApiClient from "@/libs/http-client";

// Feature switches from the backend (api/app-settings); defaults = behaviour before the switches existed
const state = {
  loaded: false,
  clientPaymentsEnabled: false, // оплат на сайті немає: картку не показувати й до відповіді API
  smsLoginEnabled: true,
  requireProviderAfterSms: false,
};

const mutations = {
  SET_SETTINGS(state, payload) {
    state.loaded = true;
    state.clientPaymentsEnabled = payload.client_payments_enabled === true;
    state.smsLoginEnabled = payload.sms_login_enabled !== false;
    state.requireProviderAfterSms = payload.require_provider_after_sms === true;
  },
};

const actions = {
  load({ commit }) {
    return ApiClient.get("api/app-settings")
      .then((response) => commit("SET_SETTINGS", response.data))
      .catch(() => {});
  },
};

const getters = {
  clientPaymentsEnabled: (state) => state.clientPaymentsEnabled,
  smsLoginEnabled: (state) => state.smsLoginEnabled,
  requireProviderAfterSms: (state) => state.requireProviderAfterSms,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
